export const checkIfIsValidPhone = (phone) => {
    if (!phone) return false;

    const phones = phone.trim().split(/\s+/).filter(Boolean);

    return phones.every((num) => {
        if (!/^\+?\d+$/.test(num)) return false;

        const digitsCount = num.replace(/\D/g, '').length;
        return digitsCount >= 9;
    });
};

export const checkIfIsValidEmail = (text) => {
    const emailRegex =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const nameIsEmail = emailRegex.test(text.trim().toLowerCase());
    return nameIsEmail;
};

export const checkIfIsValidCif = (cif) => {
    if (cif.length < 8) return false;
    const regex = /^[A-Z0-9]+$/;
    return regex.test(cif);
};
